import { atom } from "recoil";

export const listHighlighter = atom({
  key: "listHighlighter",
  default: false,
});